import { Pipe, PipeTransform } from '@angular/core';
import { IStayPriceRow } from "../interfaces/stay-price-row";
import {IVehicleRentalPriceRow} from "../../vehicle-rental-price-tab/interfaces/vehicle-rental-price-intefaces";

@Pipe({
    name: 'headerClass'
})

export class HeaderClassPipe implements PipeTransform {
    public transform(row: IStayPriceRow | IVehicleRentalPriceRow): boolean {
        return Boolean(row.collapser);
    }
}